import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

function AuthProtect() {

  const currentUser = useSelector((state) => state.user.userToken)

  return (
    currentUser ? <Outlet /> : <Navigate to='/admin/login'></Navigate>
  )
}

export default AuthProtect;